import {
  getPaginated,
  PaginatedResponse,
} from "@/application/api/getPaginated";
import { AxiosResponse } from "axios";
import { PageIndexResource, PageShowResource } from "@/modules/support/types";
import { get, put } from "@/application/api";
import { LanguageValueEnum } from "@/modules/support/enums";

export const pageIndex = async (
  language: LanguageValueEnum
): Promise<AxiosResponse<PaginatedResponse<PageIndexResource[]>>> => {
  return getPaginated(`page?language=${language}`, {});
};

export const pageUpdate = ({
  pageLanguageId,
  data,
}: {
  pageLanguageId: string | number;
  data: { title: string; content?: string };
}): Promise<AxiosResponse> => {
  return put(`page/${pageLanguageId}`, data);
};

export const pageShow = (
  pageSlug: string,
  language: LanguageValueEnum
): Promise<
  AxiosResponse<{
    data: PageShowResource;
  }>
> => get(`page/${pageSlug}?language=${language}`);
